/*
 * @Author: K
 * @Date: 2022-04-08 16:23:14
 * @LastEditors: owen
 * @LastEditTime: 2022-04-19 18:54:41
 * @FilePath: \app-pcweb\src\store\modules\HeadPortrait.js
 */
import { getHeadPortrait, setHeadPortrait } from "@/lobby_common/utils/auth";
const UserIcon = 1;
const HeadPortrait = {
  state: {
    HeadPortraiIMG: getHeadPortrait("HeadPortrait") !== "" ? getHeadPortrait("HeadPortrait") : UserIcon,
  },
  mutations: {
    setHeadIMG(state, newSetHeadIMG) {
      state.HeadPortraiIMG = newSetHeadIMG; // 修改state里的tokenInfo
    },
  },
  actions: {
    getMineBaseApi({ commit }, url) {
      commit("setHeadIMG", url);
    },
  },
  getters: {
    HeadPortraiIMG(state) {
      if (getHeadPortrait("HeadPortrait") === null) {
        setHeadPortrait(UserIcon);
      }
      return state.HeadPortraiIMG || getHeadPortrait("HeadPortrait");
    },
  },
};

export default HeadPortrait;
